module.exports = __webpack_public_path__ + "static/media/malquerida.2b59dd42.jpg";